import { render, staticRenderFns } from "./ModalOrderProductComponent.vue?vue&type=template&id=69c2d96f"
import script from "./ModalOrderProductComponent.vue?vue&type=script&lang=js"
export * from "./ModalOrderProductComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports